import React, { FunctionComponent, ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import VideoControl from '../VideoControl'
import { TestID } from '../../utils/PropTypesDefinitions'

export type VideoControlsTopProps = {
    orientation: 'portrait' | 'landscape'
    onVolumeStateChange: () => void
    onChromcast: () => void
    fontelloIconType: 'volume-on-active' | 'volume-off-active'
    onShare?: () => void
    onClose?: () => void
} & TestID

const color = 'WHITE'

const VideoControlsTop: FunctionComponent<VideoControlsTopProps> = ({
    orientation,
    onVolumeStateChange,
    onChromcast,
    fontelloIconType,
    onShare,
    onClose,
    testID,
}): ReactElement => {
    const controlsSpacing = orientation === 'landscape' ? 32 : 5
    const fontSize = orientation === 'landscape' ? 18 : 15
    return (
        <Grid
            horizontal
            height={44}
            centerVertical
            noExpand
            testID={testID}
            backgroundColor="BLACK"
        >
            {onClose ? (
                <VideoControl
                    name="close-x"
                    fontSize={fontSize}
                    color={color}
                    marginLeft={5}
                    onPress={onClose}
                />
            ) : null}
            <Grid />
            {onShare ? (
                <VideoControl
                    name="share-android"
                    fontSize={fontSize}
                    color={color}
                    onPress={onShare}
                />
            ) : null}

            <Grid noExpand marginX={controlsSpacing}>
                <VideoControl
                    name={fontelloIconType}
                    color={color}
                    fontSize={fontSize}
                    onPress={onVolumeStateChange}
                />
            </Grid>
            <VideoControl
                name="chromecast"
                fontSize={fontSize}
                color={color}
                marginRight={5}
                onPress={onChromcast}
            />
        </Grid>
    )
}

export default memo(VideoControlsTop)
